// Tabelas fiscais oficiais SAF-T (AO) — espelho de backend/fiscal.py (Decreto Presidencial 312/18, Lei 42/20 e CIVA)
export const TAX_CODES = [
  { code: "NOR", description: "IVA Taxa Normal", percentage: 14 },
  { code: "RED", description: "IVA Taxa Reduzida", percentage: 7 },
  { code: "INT", description: "IVA Taxa Intermédia", percentage: 5 },
  { code: "ISE", description: "IVA Isento", percentage: 0 },
  { code: "OUT", description: "Outros / não sujeito", percentage: 0 },
];

export const EXEMPTION_REASONS = [
  { code: "M00", description: "IVA – Regime Simplificado" },
  { code: "M02", description: "Transmissão de bens e serviços não sujeita" },
  { code: "M04", description: "IVA – Regime de Exclusão" },
  { code: "M10", description: "Isento — al. a) n.º 1 art. 12.º CIVA" },
  { code: "M11", description: "Isento — al. b) n.º 1 art. 12.º CIVA" },
  { code: "M12", description: "Isento — al. c) n.º 1 art. 12.º CIVA" },
  { code: "M13", description: "Isento — al. d) n.º 1 art. 12.º CIVA" },
  { code: "M14", description: "Isento — al. e) n.º 1 art. 12.º CIVA" },
  { code: "M15", description: "Isento — al. f) n.º 1 art. 12.º CIVA" },
  { code: "M16", description: "Isento — al. g) n.º 1 art. 12.º CIVA" },
  { code: "M17", description: "Isento — al. h) n.º 1 art. 12.º CIVA" },
  { code: "M18", description: "Isento — al. i) n.º 1 art. 12.º CIVA" },
  { code: "M19", description: "Isento — al. j) n.º 1 art. 12.º CIVA" },
  { code: "M20", description: "Isento — al. k) n.º 1 art. 12.º CIVA" },
  { code: "M21", description: "Isento — al. l) n.º 1 art. 12.º CIVA" },
  { code: "M22", description: "Isento — al. m) art. 12.º CIVA" },
  { code: "M23", description: "Isento — al. n) art. 12.º CIVA" },
  { code: "M24", description: "Isento — al. o) art. 12.º CIVA" },
  { code: "M30", description: "Isento — al. a) art. 15.º CIVA (exportações)" },
  { code: "M31", description: "Isento — al. b) art. 15.º CIVA" },
  { code: "M32", description: "Isento — al. c) art. 15.º CIVA" },
  { code: "M33", description: "Isento — al. d) art. 15.º CIVA" },
  { code: "M34", description: "Isento — al. e) art. 15.º CIVA" },
  { code: "M35", description: "Isento — al. f) art. 15.º CIVA" },
  { code: "M36", description: "Isento — al. g) art. 15.º CIVA" },
  { code: "M37", description: "Isento — al. h) art. 15.º CIVA" },
  { code: "M38", description: "Isento — al. i) art. 15.º CIVA" },
  { code: "M80", description: "Isento — al. a) n.º 1 art. 14.º (importações)" },
  { code: "M81", description: "Isento — al. b) n.º 1 art. 14.º" },
  { code: "M82", description: "Isento — al. c) n.º 1 art. 14.º" },
  { code: "M83", description: "Isento — al. d) n.º 1 art. 14.º" },
  { code: "M84", description: "Isento — al. e) n.º 1 art. 14.º" },
  { code: "M85", description: "Isento — al. a) n.º 2 art. 14.º" },
  { code: "M86", description: "Isento — al. b) n.º 2 art. 14.º" },
  { code: "M90", description: "Isento — al. a) n.º 1 art. 16.º" },
  { code: "M91", description: "Isento — al. b) n.º 1 art. 16.º" },
  { code: "M92", description: "Isento — al. c) n.º 1 art. 16.º" },
  { code: "M93", description: "Isento — al. d) n.º 1 art. 16.º" },
  { code: "M94", description: "Isento — al. e) n.º 1 art. 16.º" },
];

export const exemptionLabel = (code) => {
  const r = EXEMPTION_REASONS.find((x) => x.code === code);
  return r ? `${r.code} — ${r.description}` : code || "";
};

export const DOC_TYPE_LABELS = {
  FT: "Factura",
  FR: "Factura-Recibo",
  NC: "Nota de Crédito",
  ND: "Nota de Débito",
  CM: "Consulta de Mesa",
  RC: "Recibo",
};

export const PAYMENT_LABELS = {
  NU: "Numerário",
  CC: "Cartão de crédito",
  CD: "Cartão de débito",
  TB: "Transferência bancária",
  MB: "Multicaixa",
  DE: "Pagamento electrónico",
  CO: "Cartão de consumo / oferta",
  OU: "Outro",
};

// Menção obrigatória (Anexo I n.º 24/34): 4 caracteres da assinatura + "Processado por programa validado n.º X/AGT"
export const processedByText = (doc) => {
  const n = String(doc.software_validation_number || "0");
  return `${doc.hash_print || ""}${doc.hash_print ? "-" : ""}Processado por programa validado n.º ${n}${n.includes("/AGT") ? "" : "/AGT"}`;
};
